import React from 'react';
import { motion } from 'framer-motion';
export function WhyUs() {
  const pillars = [{
    icon: '🔬',
    title: 'Basado en Ciencia',
    text: 'Cada método está respaldado por evidencia científica actual, explicada en lenguaje simple y aplicable.'
  }, {
    icon: '🎯',
    title: 'Resultados Reales',
    text: 'Protocolos paso a paso diseñados para personas reales, con vidas ocupadas y sin conocimientos previos.'
  }, {
    icon: '🌿',
    title: '100% Natural',
    text: 'Sin medicamentos, sin dietas extremas, sin sacrificios imposibles. Solo hábitos sostenibles que funcionan.'
  }];
  return <section id="nosotros" className="py-24 bg-brand-emerald text-white" data-id="element-236">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-237">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-238">
          <h2 className="font-display text-4xl lg:text-5xl font-bold mb-4" data-id="element-239">
            ¿Por qué El Código del Bienestar?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-240">
          {pillars.map((pillar, index) => <motion.div key={index} className="bg-emerald-900/50 border border-brand-mint/20 rounded-2xl p-8 hover:bg-emerald-900/70 transition-colors duration-300" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} data-id="element-241">
              <div className="text-4xl mb-6 bg-brand-mint/10 w-16 h-16 rounded-xl flex items-center justify-center" data-id="element-242">
                {pillar.icon}
              </div>
              <h3 className="font-display text-2xl font-bold mb-4 text-brand-mint" data-id="element-243">
                {pillar.title}
              </h3>
              <p className="text-white/80 leading-relaxed" data-id="element-244">{pillar.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}